import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PowerSupply } from '@psnb/psnb-api';
import { isDefinedNotNull } from '@psnb/services';
import { PowerSupplySelectionData } from './power-supply-selection-dialog.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'psnb-power-supply-selection-dialog',
  styleUrls: ['./power-supply-selection-dialog.component.scss'],
  templateUrl: './power-supply-selection-dialog.component.html'
})
export class PowerSupplySelectionDialogComponent {
  public constructor(
    @Inject(MAT_DIALOG_DATA) public readonly powerSupplyData: PowerSupplySelectionData,
    private readonly dialogRef: MatDialogRef<PowerSupplySelectionDialogComponent>
  ) {}

  /**
   * Handles power supply selection.
   * Closes the dialog and returns the selected power supply.
   *
   * @param {PowerSupply} powerSupply - The selected power supply
   */
  public selectPowerSupply(powerSupply: PowerSupply): void {
    this.dialogRef.close(powerSupply);
  }

  /**
   * Handles cancel action.
   * Closes the dialog without returning a value.
   */
  public onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * TrackBy function for power supply list to optimize change detection.
   *
   * @param {number} index - The index of the item
   * @param {PowerSupply} powerSupply - The power supply
   * @returns The power supply ID for tracking, or index as fallback
   */
  public trackByPowerSupplyId(index: number, powerSupply: PowerSupply): number {
    return powerSupply?.powerSupplyId ?? index;
  }

  /**
   * Gets display value for MAC address or shows 'N/A' if not available.
   *
   * @param {PowerSupply} powerSupply - The power supply
   * @returns The MAC address or 'N/A'
   */
  public getMacAddressDisplay(powerSupply: PowerSupply): string {
    return isDefinedNotNull(powerSupply?.macAddress) ? powerSupply.macAddress : 'N/A';
  }
}
